import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        blue1: '#326FAB',
        blue2: '#4C81B6',
        blue3: '#7FA5CB',
        blue4: '#B2C9DF',
        blue5: '#E5EDF4',
        blue6: '#F4F7FA',
        integrity: '#004C97',
        balance: '#2DBECD',
        gratitude: '#FA7268',
        community: '#8AC24A',
        opportunity: '#FFB143',
        exceptional: '#E61E50',
        respect: '#4F4F4F',
        gray2: '#767676',
        gray3: '#9F9F9F',
        gray4: '#C8C8C8',
        gray5: '#E3E3E3',
        gray6: '#F1F1F1',
        black: '#000000',
        white: '#FFFFFF'
      }
    }
  },
  icons: {
    iconfont: 'mdi'
  }
});
